import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

export interface DunaDeviceDebugDialogData {
  deviceIdentifier: string;
  pushToken: string;
}

@Component({
  selector: 'app-duna-device-debug-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule],
  template: `
    <h2 mat-dialog-title>Enhedsinfo</h2>
    <mat-dialog-content class="content">
      <div class="row">
        <span class="label">Device ID</span>
        <code class="value">{{ data.deviceIdentifier }}</code>
      </div>
      <div class="row">
        <span class="label">Push token</span>
        <code class="value">{{ data.pushToken }}</code>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="ref.close()">Luk</button>
    </mat-dialog-actions>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      h2 {
        font-size: 0.95rem;
        font-weight: 600;
        margin: 0;
      }
      .content {
        font-size: 0.75rem;
        padding-top: 0.5rem;
      }
      .row {
        margin-bottom: 0.75rem;
      }
      .row:last-child {
        margin-bottom: 0;
      }
      .label {
        display: block;
        color: #64748b;
        margin-bottom: 0.25rem;
      }
      .value {
        display: block;
        word-break: break-all;
        font-family: ui-monospace, monospace;
        font-size: 0.7rem;
        line-height: 1.4;
        color: #334155;
        background: #f8fafc;
        padding: 0.35rem 0.5rem;
        border-radius: 4px;
      }
    `,
  ],
})
export class DunaDeviceDebugDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DunaDeviceDebugDialogData,
    public ref: MatDialogRef<DunaDeviceDebugDialogComponent>
  ) {}
}
